import { Dispatcher } from 'src/tools/dispatcher';

export const bannerRecipeDispatchers = {
    onRecipeDeliveryConfirmationViewed: new Dispatcher(),
    onRecipeDeliveryConfirmationClicked: new Dispatcher(),
    onRecipeOnboardingClicked: new Dispatcher(),
    onRecipeAgreementClicked: new Dispatcher(),
};
